/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Mzswirtschaft13Inputs */

const en__field_enum_mzswirtschaft13 = /** @type {(inputs: _Field_Enum_Mzswirtschaft13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`economics`)
};

const de__field_enum_mzswirtschaft13 = /** @type {(inputs: _Field_Enum_Mzswirtschaft13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "economics" |
*
* @param {_Field_Enum_Mzswirtschaft13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_mzswirtschaft13 = /** @type {((inputs?: _Field_Enum_Mzswirtschaft13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Mzswirtschaft13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_mzswirtschaft13(inputs)
	return de__field_enum_mzswirtschaft13(inputs)
});
export { _field_enum_mzswirtschaft13 as "_field_enum_MZSWIRTSCHAFT" }